export default __webpack_public_path__ + "static/media/001.1b2426ed.png";